import { ExternalLink } from "lucide-react";
import type { VerifiedFact } from "../types";
import { CopyButton } from "./CopyButton";
import { SourceBlock } from "./SourceBlock";
import { StatusBadge } from "./StatusBadge";
import { UsageBadge } from "./UsageBadge";
import { WarningCallout } from "./WarningCallout";

export function FactDetails({ fact }: { fact: VerifiedFact }) {
  const withSource = `${fact.title}: ${fact.value}\nИсточник: ${fact.sourceTitle}\nПроверено: ${fact.lastVerifiedAt}`;
  const sourceIsAvailable = Boolean(fact.sourceUrl && !fact.sourceUrl.startsWith("#"));

  return (
    <article className="detail-card">
      <div className="detail-card__badges">
        <StatusBadge status={fact.status} />
        <UsageBadge usage={fact.publicUsage} />
      </div>
      <span className="detail-card__category">{fact.category}</span>
      <h2>{fact.value}</h2>
      {fact.shortDescription && <p className="detail-card__lead">{fact.shortDescription}</p>}
      {fact.fullDescription && <p>{fact.fullDescription}</p>}
      {fact.status === "needs-review" && (
        <WarningCallout title="Перед публикацией">
          Перед публичным использованием уточните актуальность информации.
        </WarningCallout>
      )}
      <SourceBlock title={fact.sourceTitle} date={fact.lastVerifiedAt} url={fact.sourceUrl} note={fact.sourceNote} />
      <div className="tag-list" aria-label="Ключевые слова">
        {fact.tags.map((tag) => <span key={tag}>{tag}</span>)}
      </div>
      <div className="card-actions card-actions--stack-mobile">
        <CopyButton text={fact.value} label="Скопировать факт" />
        <CopyButton text={withSource} label="Факт с источником" />
        {sourceIsAvailable && (
          <a className="button button--primary" href={fact.sourceUrl} target="_blank" rel="noreferrer">
            Открыть источник <ExternalLink size={17} aria-hidden="true" />
          </a>
        )}
      </div>
    </article>
  );
}
